export async function fetchJson(path) {
  let response;
  try {
    response = await fetch(path);
  }
  catch (error) {
    throw new FetchError(error, 'get', path);
  }
  if (!response || !response.ok) {
    throw new FetchError(response, 'get', path);
  }
  if (response.status === 204) {
    // No content
    return null;
  }
  return await response.json();
}
export class FetchError extends Error {
  constructor(response, method, path) {
    super(`JSON request failed (${method.toUpperCase()} ${path}) with HTTP status ${response === null || response === void 0 ? void 0 : response.status}`);
    this.response = response;
    this.method = method;
    this.path = path;
  }
}
//# sourceMappingURL=fetch.js.map
